import React, { useState } from 'react';

const CustomizationManager = ({
  types = [],
  ingredients = [],
  onAddType,
  onUpdateType,
  onDeleteType,
  onAddIngredient,
  onUpdateIngredient,
  onDeleteIngredient
}) => {
  const [typeName, setTypeName] = useState('');
  const [editingType, setEditingType] = useState(null);

  const [ingredientForm, setIngredientForm] = useState({ name: '', price: '', type: '' });
  const [editingIngredient, setEditingIngredient] = useState(null);

  const submitType = (e) => {
    e.preventDefault();
    if (!typeName.trim()) return;
    if (editingType) {
      onUpdateType(editingType.id, { ...editingType, name: typeName });
      setEditingType(null);
    } else {
      onAddType({ name: typeName });
    }
    setTypeName('');
  };

  const startEditType = (t) => {
    setEditingType(t);
    setTypeName(t.name);
  };

  const submitIngredient = (e) => {
    e.preventDefault();
    if (!ingredientForm.name.trim()) return;
    const payload = { name: ingredientForm.name, price: parseFloat(ingredientForm.price) || 0, type: ingredientForm.type };
    if (editingIngredient) {
      onUpdateIngredient(editingIngredient.id, payload);
      setEditingIngredient(null);
    } else {
      onAddIngredient(payload);
    }
    setIngredientForm({ name: '', price: '', type: '' });
  };

  const startEditIngredient = (ing) => {
    setEditingIngredient(ing);
    setIngredientForm({ name: ing.name, price: ing.price, type: ing.type });
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-xl font-bold mb-4">Personalización / Tipos e Ingredientes</h3>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h4 className="font-semibold mb-2">Tipos (ej: Jugo, Licuado)</h4>
          <form onSubmit={submitType} className="flex space-x-2 mb-4">
            <input value={typeName} onChange={(e)=>setTypeName(e.target.value)} placeholder="Nombre del tipo" className="flex-1 px-3 py-2 border rounded" />
            <button type="submit" className="px-3 py-2 bg-green-600 text-white rounded">{editingType ? 'Guardar' : 'Agregar'}</button>
          </form>

          <ul className="space-y-2">
            {types.map(t => (
              <li key={t.id} className="flex justify-between items-center border rounded p-2">
                <div>{t.name}</div>
                <div className="space-x-2">
                  <button onClick={() => startEditType(t)} className="px-2 py-1 bg-gray-200 rounded">Editar</button>
                  <button onClick={() => onDeleteType(t.id)} className="px-2 py-1 bg-red-500 text-white rounded">Borrar</button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-2">Ingredientes</h4>
          <form onSubmit={submitIngredient} className="space-y-2 mb-4">
            <input value={ingredientForm.name} onChange={(e)=>setIngredientForm({...ingredientForm, name: e.target.value})} placeholder="Nombre" className="w-full px-3 py-2 border rounded" />
            <input value={ingredientForm.price} onChange={(e)=>setIngredientForm({...ingredientForm, price: e.target.value})} placeholder="Precio" className="w-full px-3 py-2 border rounded" />
            <select value={ingredientForm.type} onChange={(e)=>setIngredientForm({...ingredientForm, type: e.target.value})} className="w-full px-3 py-2 border rounded">
              <option value="">Selecciona tipo</option>
              {types.map(t=> <option key={t.id} value={t.name}>{t.name}</option>)}
            </select>
            <div className="flex justify-end">
              <button type="submit" className="px-3 py-2 bg-green-600 text-white rounded">{editingIngredient ? 'Guardar' : 'Agregar'}</button>
            </div>
          </form>

          <ul className="space-y-2">
            {ingredients.map(i => (
              <li key={i.id} className="flex justify-between items-center border rounded p-2">
                <div>
                  <div className="font-medium">{i.name} <span className="text-sm text-gray-600">(${(i.price||0).toFixed(2)})</span></div>
                  <div className="text-sm text-gray-500">Tipo: {i.type || '-'}</div>
                </div>
                <div className="space-x-2">
                  <button onClick={() => startEditIngredient(i)} className="px-2 py-1 bg-gray-200 rounded">Editar</button>
                  <button onClick={() => onDeleteIngredient(i.id)} className="px-2 py-1 bg-red-500 text-white rounded">Borrar</button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CustomizationManager;
